import React from "react";
import cn from "classnames";

import { HeadingProps } from "../Heading.props";
import styles from "./H4.module.scss";

/**
 * @deprecated
 */
const H4: React.FC<HeadingProps> = ({ children, id, testId, className, roboto, large, semiBold }: HeadingProps): JSX.Element => {
  const headerClasses = cn(
    styles["h4"],
    { [styles["roboto"]]: roboto },
    { [styles["large"]]: large },
    { "semi-bold": semiBold },
    className,
  );

  return (
    <h4 className={headerClasses} id={id} data-testid={testId ? `test__${testId}` : undefined}>
      {children}
    </h4>
  );
};

/**
 * @deprecated
 */
export default H4;
